import {ADD_NEW_BANNER, REMOVE_BANNER} from "../constants/banners";

export const addNewBanner = ({ key, banner }) => ({type: ADD_NEW_BANNER, key, banner});
export const removeBanner = ({ key }) => ({type: REMOVE_BANNER, key});